import { TicketDesignTypes } from '../../models';
import { Injectable, NgZone } from '@angular/core';
import { FileObject, MetaData, FileInclMetaData, TicketDesignUsage, TicketDesign, DefaultTicketDesign } from '../../models';
import { OauthHelper } from '../webservice'
import { Constants } from '../constants';
import { Observable, Observer } from 'rxjs/Rx';
import { HttpClient } from './http-client.service';
import { Response } from '@angular/http';

@Injectable()
export class TicketDesignApi {
	private static XHR_FINISHED_STATE = 4;
	private DESIGN_URL = "/api/deliveries/v1/ticketDesign"
	private DESIGN_USAGE_URL = "/api/deliveries/v1/ticketDesignUsages"
	private URL = "/api/deliveries/v1"
	constructor(private oauthHelper: OauthHelper, private ngZone: NgZone, private httpClient: HttpClient) {

	}

	public saveTicketDesignUsageTicketPrint(designUuid: string, eventUuid: string): Observable<TicketDesignUsage> {
		return this.httpClient.post(ZUUL_BACKEND + this.DESIGN_USAGE_URL + "/" + designUuid + "/event/ticketPrint", JSON.stringify(eventUuid))
			.map(response => response.json())
			.catch(this.handleError)
	}

	public saveTicketDesignUsagePrintAtHome(designUuid: string, eventUuid: string): Observable<TicketDesignUsage> {
		return this.httpClient.post(ZUUL_BACKEND + this.DESIGN_USAGE_URL + "/" + designUuid + "/event/printAtHome", JSON.stringify(eventUuid))
			.map(response => response.json())
			.catch(this.handleError)
	}

	public findTicketDesignUsagesByEventUuid(eventUuid: string): Observable<TicketDesignUsage[]> {
		return this.httpClient.get(ZUUL_BACKEND + this.URL + "/ticketDesignUsages/search/findByEventUUID?eventUUID=" + eventUuid)
			.map(response => response.json()._embedded.ticketDesignUsages)
			.catch(this.handleError)
	}


	public getPreview(url: string): Observable<string> {
		return this.httpClient.get(url)
			.map(response => response.text())
			.catch(this.handleError);
	}

	public deleteTicketDesign(designUuid: string):  Observable<string>  {
		return this.httpClient.delete(ZUUL_BACKEND + this.DESIGN_URL + "/" + designUuid)
			.map(response => response.text())
			.catch(this.handleError);
	}

	public deleteTicketDesignUsage(ticketDesignUsageUuid: string):  Observable<string>  {
		return this.httpClient.delete(ZUUL_BACKEND + this.DESIGN_USAGE_URL + "/" + ticketDesignUsageUuid)
			.map(response => response.text())
			.catch(this.handleError);
	}

	public uploadTicketDesign(file: File): Observable<Event> {
		return Observable.create((observer: Observer<Event>) => {
			let xhr = new XMLHttpRequest();
			let form = new FormData();
			form.append("file", file, file.name)

			xhr.open("POST", ZUUL_BACKEND + this.DESIGN_URL)
			xhr.setRequestHeader('Authorization', "Bearer " + this.oauthHelper.getAccessToken());
			xhr.setRequestHeader('accept', 'application/json')
			if (localStorage.getItem(Constants.SESSION_ID) != null) {
				xhr.setRequestHeader(Constants.SESSION_ID_HEADER, localStorage.getItem(Constants.SESSION_ID));
			}
			xhr.upload.onabort = (e) => {
				this.ngZone.run(() => observer.error(e));
			}
			xhr.upload.onprogress = (e) => {
				this.ngZone.run(() => observer.next(e));
			}
			xhr.upload.onerror = (e) => {
				this.ngZone.run(() => observer.error(e));
			}
			xhr.upload.onloadstart = (e) => {
				this.ngZone.run(() => observer.next(e));
			}
			xhr.upload.onload = (e) => {
				this.ngZone.run(() => observer.next(e));
			}
			xhr.upload.onloadend = (e) => {
				this.ngZone.run(() => observer.next(e));
			}

			xhr.onreadystatechange = (e) => {
				if (TicketDesignApi.XHR_FINISHED_STATE === xhr.readyState) {
					console.log(xhr.status)
					if (xhr.status >= 400) {
						console.log("sending error")
						this.ngZone.run(() => {
							let error = new Error(file.name)
							observer.error(error)
						})
					} else {
						this.ngZone.run(() => observer.next(e))
						this.ngZone.run(() => observer.complete())
						console.log("UPLOAD FININSHED")
					}
				}
			}

			xhr.send(form);

		})
	}

	public saveDefaultTicketDesignTicketPrint(designUuid: string, merchantId: string): Observable<DefaultTicketDesign> {
		return this.httpClient.post(ZUUL_BACKEND + this.DESIGN_URL + "/" + designUuid + "/merchant/ticketPrint", merchantId)
			.map(response => response.json())
			.catch(this.handleError)
	}

	public saveDefaultTicketDesignPrintAtHome(designUuid: string, merchantId: string): Observable<DefaultTicketDesign> {
		return this.httpClient.post(ZUUL_BACKEND + this.DESIGN_URL + "/" + designUuid + "/merchant/printAtHome", merchantId)
			.map(response => response.json())
			.catch(this.handleError)
	}

	public findDefaultTicketDesignsByMerchantId (merchantId: string): Observable<DefaultTicketDesign[]> {
		return this.httpClient.get(ZUUL_BACKEND + this.DESIGN_URL + "/merchant/" + merchantId)
			.map(response => response.json()._embedded.defaultTicketDesigns)
			.catch(this.handleError)
	}

	public loadTicketDesignSvg(url: string): Observable<string> {
		return this.httpClient.get(url)
			.map(response => response.text())
			.catch(this.handleError);
	}

	private handleError = (error: Response) => {
		console.error(error);
		return Observable.throw(error.json());
	}

}



// WEBPACK FOOTER //
// ./src/app/services/webservice/ticket-design-api.service.ts